import { ReactNode } from "react";
import { ChevronIcon } from "../assets/global/Icons";
import "./Accordion.scss";

type AccordionProps = {
  title: ReactNode;
  isOpen: boolean;
  onToggle: () => void;
  children: ReactNode;
  id?: string;
  contentId?: string;
  className?: string;
};

function Accordion({
  title,
  isOpen,
  onToggle,
  children,
  id,
  contentId,
  className = "",
}: AccordionProps) {
  return (
    <section className={`accordion ${className}`} id={id}>
      <button
        className="accordion__btn"
        onClick={onToggle}
        aria-expanded={isOpen}
        aria-controls={contentId}
        type="button"
      >
        <ChevronIcon
          className={`accordion__icon ${isOpen ? "expanded" : ""}`}
        />
        <h2 className="accordion__heading">{title}</h2>
      </button>
      <div
        id={contentId}
        className={`accordion__content ${!isOpen ? "hidden" : ""}`}
      >
        {children}
      </div>
    </section>
  );
}

export default Accordion;
